__turbopack_context__.v({
  "files": "file-upload-field-module-scss-module__hvGbPW__files",
  "root": "file-upload-field-module-scss-module__hvGbPW__root",
});
